<template>
  <router-view />
</template>

<script>

import axios from 'axios';
import store from "@/store"
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { t, locale } = useI18n()
    return {
      t,
      locale,
    }
  },
  data() {
    return {
      menu: null,
      status: null
    }
  },
  async mounted() {
    await this.getMenu();
  },
  methods: {
    async getMenu() {
      this.menu = (await axios.post("/api/PegaPortal/GetSystemMenuList", { Type: "Header", SystemType: this.$store.state.systemType })).data;
      store.commit('setMenu', this.menu);
      this.status = (await axios.post("/api/PegaPortal/GetSystemMenuStatus", { Type: "Header", SystemType: this.$store.state.systemType })).data;
      store.commit('setStatus', this.status);
    }
  }
};
</script>